import { createSelector } from 'reselect'

export const getAuthState = (state) => state.auth
export const getUserInfo = createSelector([getAuthState], (repository) => repository.userInfo)
export const isDemo = createSelector(
  [getUserInfo],
  (userInfo) => userInfo.licenseData.kind === 'demo'
)
export const getCourseData = createSelector([getUserInfo], (userInfo) =>
  userInfo.course ? userInfo.course : {}
)
export const getGame = createSelector([getUserInfo], (userInfo) => userInfo.licenseData.gameName)
export const getUserLang = createSelector([getUserInfo], (userInfo) => userInfo.licenseData.lang)
